import React, { Suspense } from "react";

const ZoomableChart = React.lazy(() => import("./index").then(m => ({ default: m.ZoomableChart })));

interface ZoomableChartProps {
  data: any;
  labels: string[];
  isPreview: boolean;
  onExpand?: () => void;
}

export function ZoomableChartLazy(props: ZoomableChartProps) {
  return (
    <Suspense fallback={<div className="h-64 flex items-center justify-center">Loading chart...</div>}>
      <ZoomableChart {...props} />
    </Suspense>
  );
}